<div
  class="textarea-group-container"
  [ngClass]="{
    error: control.touched && control.errors && control.validator,
    success: control.touched && !control.errors && control.validator
  }"
>
  <label *ngIf="label" [for]="idTextarea" class="label">{{ label }}</label>
  <div class="textarea-group">
    <textarea
      [formControl]="control"
      rows="5"
      [id]="idTextarea"
      [placeholder]="placeholder"
      class="textarea"
      autocomplete="off"
      [maxlength]="maxlength"
      [minlength]="minlength"
    ></textarea>
  </div>
  <span
    class="text-caption"
    *ngIf="
      !control.validator ||
      (!(control.touched && control.errors) &&
        !(control.touched && successMessage))
    "
    >{{ textCaption }}</span
  >
  <span class="error-message" *ngIf="control.touched && control.errors">{{
    displayError(control.errors)
  }}</span>
  <span
    class="success-message"
    *ngIf="
      successMessage && control.touched && !control.errors && control.validator
    "
    >{{ successMessage }}</span
  >
</div>
